module.exports = __webpack_public_path__ + "img/logo-mobile.cadaeb70.png";